/*
 * Copyright (c) 2016 Klaus Reimer
 * SPDX-License-Identifier: MIT
 */

/** Transparent RGBA color. */
export const transparency = 0x00000000;

/** The 16 colors (In RGBA format) used by the game graphics. */
export const colorPalette = [
    0x000000ff /*  0=Black */,
    0x0000aaff /*  1=Blue */,
    0x00aa00ff /*  2=Green */,
    0x00aaaaff /*  3=Cyan */,
    0xaa0000ff /*  4=Red */,
    0xaa00aaff /*  5=Magenta */,
    0xaa5500ff /*  6=Brown */,
    0xaaaaaaff /*  7=Light Gray */,
    0x555555ff /*  8=Gray */,
    0x5555ffff /*  9=Light Blue */,
    0x55ff55ff /* 10=Light Green */,
    0x55ffffff /* 11=Light Cyan */,
    0xff5555ff /* 12=Light Red */,
    0xff55ffff /* 13=Light Magenta */,
    0xffff55ff /* 14=Yellow */,
    0xffffffff /* 15=White */
];
